<script setup>
import ActionType, { ACTION_TYPES } from '@/Common/Enum/ActionType.js';
import IconError from '@/Components/Icons/IconError.vue';
import IconCheckCircle from '@/Components/Icons/IconCheckCircle.vue';
import IconCancel from '@/Components/Icons/IconCancel.vue';
import IconInfo from '@/Components/Icons/IconInfo.vue';

defineProps({
  actionType: Object
});
</script>

<template>
  <div>
    <IconCheckCircle
      v-if="actionType === ActionType.NO_ACTION"
      :size="20"
      class="text-success shrink-0"
    />
    <IconInfo
      v-if="
        [
          ActionType.INFO,
          ACTION_TYPES.ACTION_OPTIONAL,
          ACTION_TYPES.NO_ACTION_WITH_DEFAULT
        ].includes(actionType)
      "
      :size="20"
      class="text-info shrink-0"
    />
    <IconInfo
      v-if="[ActionType.INFO_WARN].includes(actionType)"
      :size="20"
      class="text-warning shrink-0"
    />
    <IconInfo
      v-if="[ActionType.INFO_ERROR].includes(actionType)"
      :size="20"
      class="text-danger shrink-0"
    />
    <IconError
      v-if="actionType === ActionType.ACTION_RECOMMENDED"
      :size="20"
      class="text-warning shrink-0"
    />
    <IconCancel
      v-if="actionType === ActionType.ACTION_REQUIRED"
      :size="20"
      class="text-danger shrink-0 font-light"
    />
  </div>
</template>
